<template>
  <div class="p-4 md:p-6 bg-slate-50 dark:bg-gray-900 min-h-screen font-sans">
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-slate-100 dark:border-gray-700 p-4 md:p-6">
      <div class="flex justify-between items-center mb-6">
        <div class="flex items-center space-x-3">
          <div class="h-10 w-1.5 bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full"></div>
          <div>
            <h1 class="text-xl md:text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
              <Icon icon="mdi:file-document-plus-outline" class="text-indigo-600" />
              Nueva Cotización
            </h1>
          </div>
        </div>
        <router-link to="/cotizaciones" class="text-slate-500 hover:text-slate-700 dark:text-gray-400 dark:hover:text-white">
          <Icon icon="mdi:arrow-left" class="text-lg" />
          Volver
        </router-link>
      </div>

      <form @submit.prevent="guardarCotizacion" class="space-y-6">
        <!-- DATOS DEL CLIENTE -->
        <div class="bg-slate-50 dark:bg-gray-700/30 rounded-xl p-4 border border-slate-200 dark:border-gray-600">
          <h3 class="text-xs font-black text-slate-400 uppercase mb-3 flex items-center gap-2">
            <Icon icon="mdi:account" class="text-indigo-500" />
            Datos del Cliente
            <span class="ml-2 text-[10px] bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-1.5 py-0.5 rounded-full">* Requerido</span>
          </h3>
          
          <!-- Pestañas -->
          <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-0.5 rounded-xl mb-3">
            <button @click="modoCliente = 'buscar'" :class="['flex-1 px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-200', modoCliente === 'buscar' ? 'bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
              <Icon icon="mdi:magnify" class="inline mr-1" /> Buscar
            </button>
            <button @click="modoCliente = 'crear'" :class="['flex-1 px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-200', modoCliente === 'crear' ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
              <Icon icon="mdi:account-plus" class="inline mr-1" /> Nuevo
            </button>
          </div>

          <!-- Modo Buscar Cliente -->
          <div v-if="modoCliente === 'buscar'" class="relative">
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-2">Buscar Cliente Existente</label>
            <div class="relative">
              <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input v-model="buscarCliente" type="text" placeholder="Nombre, documento, teléfono o email..." class="w-full pl-10 pr-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-green-500 text-sm transition-all" @input="debounceBuscarClientes" @focus="mostrarClientesSiHay" />
            </div>
            
            <!-- Dropdown de resultados -->
            <div v-if="mostrarListaClientes && clientesEncontrados.length > 0" class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-72 overflow-y-auto z-50">
              <div v-for="(cliente, index) in clientesEncontrados" :key="cliente.idCliente || cliente.id || index" @click="seleccionarCliente(cliente)" class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                <div class="flex items-start gap-3">
                  <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                    <Icon icon="mdi:account-circle" class="text-green-600 dark:text-green-400 text-xl" />
                  </div>
                  <div class="flex-1">
                    <div class="flex justify-between items-start">
                      <div>
                        <p class="font-semibold text-gray-800 dark:text-white">{{ cliente.nombre }} {{ cliente.apellido }}</p>
                        <p class="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ formatearTipoDocumento(cliente.tipoDocumento) }}: <span class="font-mono">{{ cliente.documento }}</span></p>
                        <div class="flex items-center gap-3 mt-1 text-xs text-gray-500 dark:text-gray-400">
                          <span v-if="cliente.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-1 text-xs" />{{ cliente.telefono }}</span>
                        </div>
                      </div>
                      <Icon v-if="form.idCliente === cliente.idCliente" icon="mdi:check-circle" class="text-green-500 text-2xl" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="buscarCliente && buscarCliente.trim().length >= 2 && !cargandoClientes && clientesEncontrados.length === 0" class="absolute mt-2 w-full p-6 text-center bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 z-50">
              <Icon icon="mdi:account-search" class="text-4xl text-gray-400 mx-auto mb-2" />
              <p class="text-gray-600 dark:text-gray-400 mb-3">No encontramos "{{ buscarCliente }}"</p>
              <button @click="modoCliente = 'crear'" class="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center gap-2">
                <Icon icon="mdi:account-plus" />Crear este cliente
              </button>
            </div>
            
            <div v-if="cargandoClientes" class="absolute mt-2 w-full p-4 text-center bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-2xl z-50">
              <div class="inline-block animate-spin rounded-full h-5 w-5 border-2 border-green-500 border-t-transparent"></div>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">Buscando clientes...</p>
            </div>
          </div>

          <!-- Modo Crear Cliente -->
          <div v-if="modoCliente === 'crear'">
            <form @submit.prevent="guardarNuevoCliente" class="space-y-4">
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo Documento <span class="text-red-500">*</span></label>
                  <select v-model="nuevoCliente.tipoDocumento" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all">
                    <option value="">Seleccionar...</option>
                    <option value="cedula">Cédula de Identidad</option>
                    <option value="rif">RIF</option>
                    <option value="pasaporte">Pasaporte</option>
                    <option value="identificacion_extranjera">Identificación Extranjera</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Número Documento <span class="text-red-500">*</span></label>
                  <input v-model="nuevoCliente.documento" type="text" :placeholder="getPlaceholderDocumento(nuevoCliente.tipoDocumento)" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all" @blur="formatearDocumentoInput" />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre <span class="text-red-500">*</span></label>
                  <input v-model="nuevoCliente.nombre" type="text" placeholder="Ej: Juan Carlos" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all" @blur="nuevoCliente.nombre = toTitleCase(nuevoCliente.nombre)" />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Apellido</label>
                  <input v-model="nuevoCliente.apellido" type="text" placeholder="Ej: Rodríguez" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all" @blur="nuevoCliente.apellido = toTitleCase(nuevoCliente.apellido)" />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Teléfono</label>
                  <input v-model="nuevoCliente.telefono" type="text" placeholder="0414-7470715" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all" @blur="formatearTelefonoInput" />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
                  <input v-model="nuevoCliente.email" type="email" placeholder="ejemplo@email.com" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all" />
                </div>
                <div class="col-span-2">
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Dirección <span class="text-red-500">*</span></label>
                  <textarea v-model="nuevoCliente.direccion" rows="2" placeholder="Dirección completa del cliente..." class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm transition-all resize-none" @blur="nuevoCliente.direccion = toTitleCase(nuevoCliente.direccion)"></textarea>
                </div>
              </div>
              <div class="flex gap-3 pt-2">
                <button type="submit" :disabled="!puedeGuardarCliente || guardandoCliente" :class="['flex-1 px-4 py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 font-medium', puedeGuardarCliente && !guardandoCliente ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-700 hover:to-indigo-700 shadow-md hover:shadow-lg' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                  <Icon v-if="guardandoCliente" icon="mdi:loading" class="animate-spin text-lg" />
                  <Icon v-else icon="mdi:account-plus" class="text-lg" />
                  {{ guardandoCliente ? 'Guardando...' : 'Guardar y Seleccionar' }}
                </button>
                <button type="button" @click="modoCliente = 'buscar'" class="flex-1 px-4 py-2 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200">Cancelar</button>
              </div>
            </form>
          </div>
          
          <!-- Cliente Seleccionado -->
          <div v-if="clienteSeleccionado" class="mt-6 p-5 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-green-200 dark:border-green-800/50">
            <div class="flex items-start gap-3">
              <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                <Icon icon="mdi:account-check" class="text-green-600 dark:text-green-400 text-2xl" />
              </div>
              <div class="flex-1">
                <div class="flex justify-between items-start">
                  <div>
                    <p class="font-semibold text-gray-800 dark:text-white text-lg">{{ clienteSeleccionado.nombre }} {{ clienteSeleccionado.apellido }}</p>
                    <p class="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ formatearTipoDocumento(clienteSeleccionado.tipoDocumento) }}: <span class="font-mono">{{ clienteSeleccionado.documento }}</span></p>
                    <div class="flex flex-wrap gap-3 mt-2 text-sm text-gray-600 dark:text-gray-400">
                      <span v-if="clienteSeleccionado.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-1 text-gray-400" />{{ clienteSeleccionado.telefono }}</span>
                    </div>
                  </div>
                  <button @click="deseleccionarCliente" class="p-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200" title="Cambiar cliente">
                    <Icon icon="mdi:close" class="text-xl" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FECHA DE VALIDEZ -->
        <div class="bg-slate-50 dark:bg-gray-700/30 rounded-xl p-4 border border-slate-200 dark:border-gray-600">
          <h3 class="text-xs font-black text-slate-400 uppercase mb-3 flex items-center gap-2">
            <Icon icon="mdi:calendar-clock" class="text-indigo-500" />
            Fecha de Validez
            <span class="ml-2 text-[10px] bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-1.5 py-0.5 rounded-full">* Requerido</span>
          </h3>
          <div>
            <label class="block text-[10px] font-black text-slate-400 uppercase mb-1.5 ml-1">Fecha de Validez *</label>
            <input v-model="form.fechaValidez" type="date" required class="w-full bg-white dark:bg-gray-800 border-2 border-slate-200 dark:border-gray-600 rounded-xl px-4 py-2.5 text-xs text-slate-700 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all font-bold" />
            <p v-if="!form.fechaValidez" class="text-[10px] text-amber-500 mt-1">⚠️ Seleccione una fecha de validez</p>
          </div>
        </div>

        <!-- ITEMS - 100% RESPONSIVE -->
        <div class="bg-slate-50 dark:bg-gray-700/30 rounded-xl p-4 border border-slate-200 dark:border-gray-600">
          <div class="flex flex-wrap justify-between items-center gap-2 mb-3">
            <h3 class="text-xs font-black text-slate-400 uppercase flex items-center gap-2">
              <Icon icon="mdi:format-list-bulleted" class="text-indigo-500" />
              Items
              <span class="text-[10px] bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 px-2 py-0.5 rounded-full ml-1">{{ form.detalles.length }}</span>
            </h3>
            <div class="flex flex-wrap gap-2">
              <button type="button" @click="abrirModalConfiguracionItem('servicio')" class="py-1.5 px-3 rounded-xl transition-all duration-200 flex items-center gap-1 text-[10px] font-black uppercase bg-white dark:bg-gray-800 border border-green-200 dark:border-green-800 text-green-600 dark:text-green-400 shadow-sm hover:shadow-md hover:bg-green-50 dark:hover:bg-green-900/20 active:scale-95">
                <Icon icon="mdi:wrench" class="text-sm" /> <span class="hidden xs:inline">Agregar</span> Servicio
              </button>
              <button type="button" @click="abrirModalConfiguracionItem('producto')" class="py-1.5 px-3 rounded-xl transition-all duration-200 flex items-center gap-1 text-[10px] font-black uppercase bg-white dark:bg-gray-800 border border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400 shadow-sm hover:shadow-md hover:bg-blue-50 dark:hover:bg-blue-900/20 active:scale-95">
                <Icon icon="mdi:package-variant" class="text-sm" /> <span class="hidden xs:inline">Agregar</span> Producto
              </button>
            </div>
          </div>

          <!-- Lista de items agregados -->
          <div v-if="form.detalles.length === 0" class="text-center py-6">
            <Icon icon="mdi:package-variant-remove" class="text-4xl text-gray-300 mx-auto mb-2" />
            <p class="text-xs text-gray-400">No hay items agregados</p>
            <p class="text-[10px] text-gray-400 mt-1">Haz clic en "Agregar Servicio" o "Agregar Producto"</p>
          </div>

          <div v-for="(item, index) in form.detalles" :key="index" class="bg-white dark:bg-gray-800 rounded-xl p-3 mb-2 border border-slate-200 dark:border-gray-600 hover:shadow-sm transition-shadow">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <!-- Lado izquierdo: Icono + Nombre + Badges -->
              <div class="flex items-start sm:items-center gap-3 flex-1 min-w-0">
                <div class="p-1.5 rounded-lg shrink-0 mt-0.5 sm:mt-0" :class="item.tipoItem === 'servicio' ? 'bg-green-100 dark:bg-green-900/30 text-green-600' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-600'">
                  <Icon :icon="item.tipoItem === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-sm" />
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-[11px] sm:text-xs font-bold text-gray-800 dark:text-white truncate">
                    {{ item.descripcionManual || (item.productoSeleccionado?.nombre || item.servicioSeleccionado?.nombre || '') }}
                  </p>
                  <div class="flex items-center gap-1.5 flex-wrap mt-0.5">
                    <span class="text-[7px] sm:text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ item.tipoItem }}</span>
                    <span v-if="item.cantidad && item.cantidad > 1" class="text-[7px] sm:text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ item.cantidad }}</span>
                    <span v-if="item.garantiaMeses > 0" class="text-[7px] sm:text-[8px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                      {{ item.garantiaMeses }} mes{{ item.garantiaMeses > 1 ? 'es' : '' }}
                    </span>
                    <span v-if="item.descuentoPorcentaje > 0" class="text-[7px] sm:text-[8px] font-black bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300 px-1.5 py-0.5 rounded-full">
                      -{{ item.descuentoPorcentaje }}%
                    </span>
                  </div>
                </div>
              </div>

              <!-- Lado derecho: Precio + Cantidad + Eliminar -->
              <div class="flex items-center justify-between sm:justify-end gap-2 w-full sm:w-auto pl-9 sm:pl-0">
                <div class="flex items-center gap-2">
                  <span v-if="item.cantidad && item.cantidad > 1" class="text-[10px] font-bold text-gray-500 dark:text-gray-400">x{{ item.cantidad }}</span>
                  <span class="text-sm sm:text-base font-black text-green-600 dark:text-green-400">${{ (item.precioUnitarioUsd * (parseInt(item.cantidad) || 1)).toFixed(2) }}</span>
                </div>
                <button type="button" @click="eliminarItem(index)" class="p-1.5 text-rose-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/20 rounded-lg transition-colors">
                  <Icon icon="mdi:trash-can-outline" class="text-sm sm:text-base" />
                </button>
              </div>
            </div>
          </div>

          <!-- Resumen con TOTAL GENERAL -->
          <div v-if="form.detalles.length > 0" class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
            <div class="flex flex-wrap justify-between items-center gap-2">
              <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">Resumen de Items</span>
              <div class="flex items-center gap-4">
                <span class="text-[10px] font-black text-gray-500">{{ form.detalles.length }} item{{ form.detalles.length > 1 ? 's' : '' }}</span>
                <span class="text-sm font-black text-indigo-600 dark:text-indigo-400">${{ totalItems.toFixed(2) }}</span>
              </div>
            </div>
            <!-- Total general destacado -->
            <div class="flex justify-between items-center mt-3 pt-3 border-t-2 border-indigo-200 dark:border-indigo-800">
              <span class="text-xs font-black text-gray-600 dark:text-gray-300 uppercase tracking-wider">TOTAL GENERAL</span>
              <span class="text-xl font-black text-indigo-600 dark:text-indigo-400">${{ totalItems.toFixed(2) }}</span>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div class="flex flex-col sm:flex-row gap-3 pt-4 border-t border-slate-100 dark:border-gray-700">
          <router-link to="/cotizaciones" class="flex-1 bg-slate-100 dark:bg-gray-700 text-slate-600 dark:text-slate-300 py-2.5 rounded-xl font-bold hover:bg-slate-200 transition-all text-center text-sm">
            Cancelar
          </router-link>
          <button 
            type="submit" 
            :disabled="guardando || form.detalles.length === 0 || !form.idCliente || !form.fechaValidez" 
            :class="[
              'flex-[2] py-2.5 rounded-xl font-bold transition-all flex items-center justify-center gap-2 text-sm',
              (guardando || form.detalles.length === 0 || !form.idCliente || !form.fechaValidez) 
                ? 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed' 
                : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg shadow-indigo-200 dark:shadow-none'
            ]"
          >
            <Icon :icon="guardando ? 'mdi:loading' : 'mdi:content-save'" class="text-lg" :class="{'animate-spin': guardando}" />
            {{ guardando ? 'Guardando...' : 'Crear Cotización' }}
          </button>
        </div>
        <!-- Mensaje cuando falta algo -->
        <div v-if="!guardando" class="text-center -mt-2">
          <p v-if="!form.idCliente" class="text-[10px] text-amber-500 font-bold">⚠️ Seleccione un cliente</p>
          <p v-else-if="!form.fechaValidez" class="text-[10px] text-amber-500 font-bold">⚠️ Seleccione una fecha de validez</p>
          <p v-else-if="form.detalles.length === 0" class="text-[10px] text-amber-500 font-bold">⚠️ Debes agregar al menos un servicio o producto</p>
        </div>
      </form>
    </div>

    <!-- MODAL DE CONFIGURACIÓN DE ÍTEM -->
    <Teleport to="body">
      <div v-if="showItemConfigModal" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="closeItemConfigModal"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md flex flex-col overflow-hidden transform transition-all scale-100 animate-fadeIn">
          <div class="p-5 bg-gradient-to-r" :class="itemConfigTipo === 'servicio' ? 'from-green-600 to-emerald-700' : 'from-blue-600 to-indigo-700'">
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-3">
                <div class="p-2 bg-white/20 rounded-xl">
                  <Icon :icon="itemConfigTipo === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-2xl text-white" />
                </div>
                <div>
                  <h3 class="text-lg font-black text-white uppercase tracking-tighter">Configurar {{ itemConfigTipo === 'servicio' ? 'Servicio' : 'Producto' }}</h3>
                  <p class="text-[9px] font-bold text-white/70 uppercase tracking-widest">Ajusta precio, garantía y cantidad</p>
                </div>
              </div>
              <button @click="closeItemConfigModal" class="p-2 hover:bg-white/10 rounded-xl transition-all">
                <Icon icon="mdi:close" class="text-2xl text-white" />
              </button>
            </div>
          </div>
          
          <div class="p-5 space-y-4 bg-gray-50/50 dark:bg-gray-900/50">
            <div class="bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700">
              <p class="text-[9px] font-black text-gray-400 uppercase tracking-wider mb-1">Ítem seleccionado</p>
              <p class="font-bold text-gray-800 dark:text-white text-sm">{{ itemConfigSeleccionado?.nombre || '' }}</p>
            </div>

            <div>
              <label class="block text-[10px] font-black text-gray-500 uppercase tracking-wider mb-2">PRECIO UNITARIO (USD)</label>
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 font-black text-green-600 text-sm">$</span>
                <input v-model.number="itemConfigPrecio" type="number" step="0.01" min="0.01" class="w-full pl-8 pr-3 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-lg font-black text-green-600 dark:text-green-400 outline-none focus:border-green-500 transition-all text-right" />
              </div>
            </div>

            <div>
              <label class="block text-[10px] font-black text-gray-500 uppercase tracking-wider mb-2">GARANTÍA (DÍAS)</label>
              <div class="flex gap-2">
                <input v-model.number="itemConfigGarantia" type="number" step="1" min="0" class="flex-1 px-3 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-sm font-bold outline-none focus:border-green-500 transition-all" />
                <div class="px-3 py-3 bg-gray-100 dark:bg-gray-700 rounded-xl text-[9px] font-black text-gray-500 uppercase tracking-wider">
                  {{ formatearGarantia(itemConfigGarantia || 0) }}
                </div>
              </div>
            </div>

            <div>
              <label class="block text-[10px] font-black text-gray-500 uppercase tracking-wider mb-2">CANTIDAD</label>
              <div class="flex items-center gap-3">
                <button @click="itemConfigCantidad = Math.max(1, itemConfigCantidad - 1)" class="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-xl flex items-center justify-center font-black text-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-all">
                  <Icon icon="mdi:minus" class="text-lg" />
                </button>
                <input v-model.number="itemConfigCantidad" type="number" step="1" min="1" class="w-20 px-3 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-center text-lg font-black outline-none focus:border-green-500 transition-all [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
                <button @click="itemConfigCantidad = Math.min(999, itemConfigCantidad + 1)" class="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-xl flex items-center justify-center font-black text-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-all">
                  <Icon icon="mdi:plus" class="text-lg" />
                </button>
                <div class="flex-1 text-right">
                  <p class="text-[8px] text-gray-400 uppercase tracking-wider">TOTAL</p>
                  <p class="text-xl font-black text-green-600 dark:text-green-400">${{ (itemConfigPrecio * itemConfigCantidad).toFixed(2) }}</p>
                </div>
              </div>
            </div>

            <div class="bg-amber-50 dark:bg-amber-900/20 p-3 rounded-xl border border-amber-100 dark:border-amber-800/40 flex gap-2">
              <Icon icon="mdi:information-outline" class="text-amber-500 text-sm shrink-0" />
              <p class="text-[9px] font-bold text-amber-700 dark:text-amber-300 leading-snug">La garantía se aplica sobre el ítem completo. El precio final se multiplica por la cantidad seleccionada.</p>
            </div>
          </div>
          
          <div class="p-5 bg-white dark:bg-gray-800 border-t border-gray-100 dark:border-gray-700">
            <button @click="agregarItemConConfiguracion" class="w-full py-3.5 rounded-xl transition-all flex items-center justify-center gap-2 font-black text-sm uppercase tracking-wider shadow-lg active:scale-95" :class="itemConfigTipo === 'servicio' ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white' : 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white'">
              <Icon icon="mdi:check-circle" class="text-lg" />
              AGREGAR A LA COTIZACIÓN
            </button>
            <button @click="closeItemConfigModal" class="w-full mt-2 py-2 text-[10px] font-black text-gray-400 hover:text-gray-600 uppercase tracking-widest transition-all">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- MODAL DE SELECCIÓN DE ÍTEM DEL CATÁLOGO -->
    <Teleport to="body">
      <div v-if="showCatalogModal" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="showCatalogModal = false"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden transform transition-all scale-100 animate-fadeIn">
          <div class="p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700">
            <div class="flex justify-between items-center">
              <h3 class="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                <div class="p-2 rounded-lg" :class="catalogType === 'servicio' ? 'bg-green-100 dark:bg-green-900/30 text-green-600' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-600'">
                  <Icon :icon="catalogType === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-xl" />
                </div>
                Seleccionar {{ catalogType === 'servicio' ? 'Servicio' : 'Producto' }}
              </h3>
              <button @click="showCatalogModal = false" class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl">
                <Icon icon="mdi:close" class="text-2xl text-gray-500 dark:text-gray-400" />
              </button>
            </div>
            <div class="mt-4">
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input v-model="catalogSearch" type="text" placeholder="Buscar por nombre..." class="w-full pl-10 pr-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 font-medium outline-none" autocomplete="off" />
              </div>
            </div>
          </div>
          
          <div class="p-4 sm:p-6 overflow-y-auto flex-1 custom-scrollbar">
            <div v-if="filteredCatalogItems.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div v-for="item in filteredCatalogItems" :key="item.id" @click="seleccionarItemCatalogo(item)" class="p-4 border border-gray-200 dark:border-gray-700 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-[1.02] bg-white dark:bg-gray-800" :class="catalogType === 'servicio' ? 'hover:border-green-500' : 'hover:border-blue-500'">
                <div class="flex gap-3">
                  <div class="p-3 rounded-lg h-fit" :class="catalogType === 'servicio' ? 'bg-green-100 dark:bg-green-900/30' : 'bg-blue-100 dark:bg-blue-900/30'">
                    <Icon :icon="catalogType === 'servicio' ? 'mdi:wrench' : 'mdi:package'" class="text-2xl" :class="catalogType === 'servicio' ? 'text-green-600 dark:text-green-400' : 'text-blue-600 dark:text-blue-400'" />
                  </div>
                  <div class="flex-1">
                    <h4 class="font-semibold text-gray-900 dark:text-white">{{ item.nombre }}</h4>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ catalogType === 'servicio' ? 'Servicio Técnico' : 'Producto' }}</p>
                    
                    <div class="mt-3 flex justify-between items-center">
                      <span class="text-sm text-gray-600 dark:text-gray-400">Precio USD:</span>
                      <span class="text-lg font-bold" :class="catalogType === 'servicio' ? 'text-green-600 dark:text-green-400' : 'text-blue-600 dark:text-blue-400'">${{ (catalogType === 'servicio' ? (item.precioUsd || 0) : (item.precio_venta_usd || 0)).toFixed(2) }}</span>
                    </div>
                    <div v-if="(catalogType === 'servicio' && item.garantiaDias) || (catalogType === 'producto' && item.garantia_meses)" class="mt-2">
                      <span class="text-[9px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-2 py-0.5 rounded-full">
                        🛡️ Garantía: {{ catalogType === 'servicio' ? formatearGarantia(item.garantiaDias) : formatearGarantia((item.garantia_meses || 0) * 30) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-12">
              <Icon icon="mdi:magnify-close" class="text-5xl text-gray-400 mx-auto mb-3" />
              <p class="text-gray-600 dark:text-gray-400">No se encontraron resultados</p>
            </div>
          </div>
          
          <div class="p-4 sm:p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
            <div class="flex justify-between items-center">
              <p class="text-sm text-gray-600 dark:text-gray-400">Seleccione un elemento para configurarlo</p>
              <button @click="showCatalogModal = false" class="px-6 py-2.5 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-xl hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 font-medium">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { Icon } from '@iconify/vue';
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2';
import { crearCotizacion } from '@/api/cotizacion';
import { obtenerClientes, crearCliente, formatearDocumento, formatearTelefonoVenezolano } from '@/api/clientes.js';
import { obtenerProductos } from '@/api/productos';
import { obtenerServicios } from '@/api/servicios';
import { obtenerProductosServicios } from '@/api/productoServicio';
import { obtenerTasasVenta } from '@/api/tasaVenta';
import { obtenerFuentes as obtenerFuentesTasa } from '@/api/fuenteTasa';
import { toTitleCase } from '@/utils/stringUtils.js';

const router = useRouter();
const guardando = ref(false);

// Datos
const clientes = ref([]);
const todosLosClientes = ref([]);
const productos = ref([]);
const servicios = ref([]);
const productosServicios = ref([]);
const tasas = ref([]);
const fuentes = ref([]);

// Cliente - Modo
const modoCliente = ref('buscar');
const clienteSeleccionado = ref(null);
const buscarCliente = ref('');
const clientesEncontrados = ref([]);
const cargandoClientes = ref(false);
const mostrarListaClientes = ref(false);
const timeoutBusqueda = ref(null);

// Nuevo Cliente
const nuevoCliente = reactive({
  tipoDocumento: '',
  documento: '',
  nombre: '',
  apellido: '',
  telefono: '',
  email: '',
  direccion: '',
  estado: 'activo'
});
const guardandoCliente = ref(false);

// Configuración de ítem
const showItemConfigModal = ref(false);
const itemConfigTipo = ref('servicio');
const itemConfigSeleccionado = ref(null);
const itemConfigPrecio = ref(0);
const itemConfigGarantia = ref(0);
const itemConfigCantidad = ref(1);

// Modal de catálogo
const showCatalogModal = ref(false);
const catalogType = ref('servicio');
const catalogSearch = ref('');

const form = reactive({
  idCliente: '',
  fechaValidez: '',
  idUsuario: 1,
  tasaBsUsd: 52.00,
  idFuenteTasa: 1,
  idTasaVenta: 1,
  formaPago: '',
  condicionesPago: '',
  observaciones: '',
  idSede: 1,
  detalles: []
});

// Computed - Ahora calcula el TOTAL de todos los items (precio * cantidad)
const filteredCatalogItems = computed(() => {
  const termino = catalogSearch.value.toLowerCase().trim();
  let items = [];
  if (catalogType.value === 'servicio') {
    items = servicios.value.map(s => ({ ...s, id: s.idServicio, precio: s.precioUsd, garantiaDias: s.garantiaDias || 0 }));
  } else {
    items = productos.value.map(p => ({ ...p, id: p.idProducto, precio: p.precio_venta_usd, garantiaMeses: p.garantia_meses || 0 }));
  }
  if (!termino) return items.slice(0, 50);
  return items.filter(x => (x.nombre || '').toLowerCase().includes(termino)).slice(0, 50);
});

// 🔥 TOTAL GENERAL - Suma de todos los precios unitarios multiplicados por su cantidad
const totalItems = computed(() => {
  return form.detalles.reduce((sum, item) => sum + (parseFloat(item.precioUnitarioUsd) * (parseInt(item.cantidad) || 1)), 0);
});

const puedeGuardarCliente = computed(() => {
  return nuevoCliente.tipoDocumento && 
         nuevoCliente.documento && 
         nuevoCliente.documento.trim() !== '' && 
         nuevoCliente.nombre && 
         nuevoCliente.nombre.trim() !== '' && 
         nuevoCliente.direccion && 
         nuevoCliente.direccion.trim() !== '';
});

// Métodos
const formatearGarantia = (dias) => {
  if (!dias || dias === 0) return 'Sin garantía';
  if (dias >= 365) return `${Math.floor(dias / 365)} año${Math.floor(dias / 365) !== 1 ? 's' : ''}`;
  if (dias >= 30) return `${Math.floor(dias / 30)} mes${Math.floor(dias / 30) !== 1 ? 'es' : ''}`;
  return `${dias} día${dias !== 1 ? 's' : ''}`;
};

const formatearTipoDocumento = (tipo) => {
  const tipos = { 'cedula': 'Cédula', 'rif': 'RIF', 'pasaporte': 'Pasaporte', 'identificacion_extranjera': 'Identificación Extranjera' };
  return tipos[tipo?.toLowerCase()] || tipo || 'Sin documento';
};

const getPlaceholderDocumento = (tipo) => {
  const placeholders = { 'cedula': 'V-31.757.818', 'rif': 'J-12345678-9', 'pasaporte': 'ABC123456', 'identificacion_extranjera': 'Número' };
  return placeholders[tipo] || 'Documento';
};

const formatearDocumentoInput = () => {
  if (nuevoCliente.tipoDocumento && nuevoCliente.documento) {
    nuevoCliente.documento = formatearDocumento(nuevoCliente.tipoDocumento, nuevoCliente.documento);
  }
};

const formatearTelefonoInput = () => {
  if (nuevoCliente.telefono) {
    nuevoCliente.telefono = formatearTelefonoVenezolano(nuevoCliente.telefono);
  }
};

const eliminarItem = (index) => {
  if (form.detalles.length > 1) {
    form.detalles.splice(index, 1);
  } else {
    toast('Debe tener al menos un item', 'warning');
  }
};

// Cliente - Buscar
const debounceBuscarClientes = () => {
  mostrarListaClientes.value = true;
  if (timeoutBusqueda.value) clearTimeout(timeoutBusqueda.value);
  timeoutBusqueda.value = setTimeout(() => buscarClientesLocal(), 300);
};

const mostrarClientesSiHay = () => {
  if (!buscarCliente.value || buscarCliente.value.trim() === '') {
    clientesEncontrados.value = todosLosClientes.value.slice(0, 10);
  }
  if (clientesEncontrados.value.length > 0) mostrarListaClientes.value = true;
};

const buscarClientesLocal = () => {
  if (!buscarCliente.value || buscarCliente.value.trim() === '') {
    clientesEncontrados.value = todosLosClientes.value.slice(0, 10);
    mostrarListaClientes.value = clientesEncontrados.value.length > 0;
    cargandoClientes.value = false;
    return;
  }
  cargandoClientes.value = true;
  const termino = buscarCliente.value.toLowerCase().trim();
  setTimeout(() => {
    clientesEncontrados.value = todosLosClientes.value.filter(cliente => {
      const nombreCompleto = `${cliente.nombre || ''} ${cliente.apellido || ''}`.toLowerCase();
      const documento = (cliente.documento || '').toLowerCase();
      const telefono = (cliente.telefono || '').toLowerCase();
      const email = (cliente.email || '').toLowerCase();
      return nombreCompleto.includes(termino) || documento.includes(termino) || telefono.includes(termino) || email.includes(termino);
    }).slice(0, 10);
    cargandoClientes.value = false;
  }, 300);
};

const seleccionarCliente = (cliente) => {
  if (!cliente) return;
  
  const id = cliente.idCliente || cliente.id || cliente.id_cliente;
  if (!id) {
    toast('Error al seleccionar: ID de cliente no encontrado', 'error');
    return;
  }

  clienteSeleccionado.value = { ...cliente, idCliente: id };
  form.idCliente = id;
  buscarCliente.value = '';
  clientesEncontrados.value = [];
  mostrarListaClientes.value = false;
  toast(`Cliente ${cliente.nombre || 'seleccionado'} activado`);
};

const deseleccionarCliente = () => {
  clienteSeleccionado.value = null;
  form.idCliente = null;
  buscarCliente.value = '';
  toast('Cliente removido', 'info');
};

// Cliente - Crear
const guardarNuevoCliente = async () => {
  if (!puedeGuardarCliente.value) {
    toast('Por favor complete los campos obligatorios (Tipo, Documento, Nombre y Dirección)', 'error');
    return;
  }
  
  guardandoCliente.value = true;
  try {
    const response = await crearCliente(nuevoCliente);
    if (response.success) {
      let clienteParaSeleccionar = response.data || { ...nuevoCliente };
      const idRespuesta = clienteParaSeleccionar.idCliente || clienteParaSeleccionar.id || clienteParaSeleccionar.id_cliente;
      
      if (idRespuesta) {
        clienteParaSeleccionar.idCliente = idRespuesta;
      }

      clienteParaSeleccionar.nombre = clienteParaSeleccionar.nombre || nuevoCliente.nombre;
      clienteParaSeleccionar.apellido = clienteParaSeleccionar.apellido || nuevoCliente.apellido;
      clienteParaSeleccionar.documento = clienteParaSeleccionar.documento || nuevoCliente.documento;
      clienteParaSeleccionar.tipoDocumento = clienteParaSeleccionar.tipoDocumento || nuevoCliente.tipoDocumento;

      if (Array.isArray(todosLosClientes.value)) {
        const existe = todosLosClientes.value.find(c => c.idCliente === clienteParaSeleccionar.idCliente);
        if (!existe) {
          todosLosClientes.value.push(clienteParaSeleccionar);
        }
      }
      
      modoCliente.value = 'buscar';
      setTimeout(() => seleccionarCliente(clienteParaSeleccionar), 100);
      
      Object.assign(nuevoCliente, {
        tipoDocumento: 'cedula',
        documento: '',
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        direccion: '',
        estado: 'activo'
      });
      
      toast(`Cliente "${clienteParaSeleccionar.nombre}" creado exitosamente`);
    } else {
      throw new Error(response.error || response.message || 'Error al procesar la respuesta');
    }
  } catch (error) {
    console.error('Error creando cliente:', error);
    toast('No se pudo crear el cliente: ' + (error.message || 'Error de comunicación'), 'error');
  } finally {
    guardandoCliente.value = false;
  }
};

// MODALES DE CONFIGURACIÓN DE ÍTEM
const abrirModalConfiguracionItem = (tipo) => {
  itemConfigTipo.value = tipo;
  showCatalogModal.value = true;
  catalogType.value = tipo;
  catalogSearch.value = '';
};

const seleccionarItemCatalogo = (item) => {
  itemConfigSeleccionado.value = item;
  if (itemConfigTipo.value === 'servicio') {
    itemConfigPrecio.value = item.precioUsd || 0;
    itemConfigGarantia.value = item.garantiaDias || 0;
  } else {
    itemConfigPrecio.value = item.precio_venta_usd || 0;
    itemConfigGarantia.value = (item.garantia_meses || 0) * 30;
  }
  itemConfigCantidad.value = 1;
  showCatalogModal.value = false;
  showItemConfigModal.value = true;
};

const agregarItemConConfiguracion = () => {
  if (!itemConfigSeleccionado.value) return;
  if (itemConfigPrecio.value <= 0) {
    toast('El precio debe ser mayor a cero', 'warning');
    return;
  }
  if (itemConfigCantidad.value < 1) {
    toast('La cantidad debe ser al menos 1', 'warning');
    return;
  }
  
  const nuevoItem = {
    tipoItem: itemConfigTipo.value,
    idProducto: itemConfigTipo.value === 'producto' ? itemConfigSeleccionado.value.id : null,
    idServicio: itemConfigTipo.value === 'servicio' ? itemConfigSeleccionado.value.id : null,
    idProductoServicios: null,
    productoSeleccionado: itemConfigTipo.value === 'producto' ? itemConfigSeleccionado.value : null,
    servicioSeleccionado: itemConfigTipo.value === 'servicio' ? itemConfigSeleccionado.value : null,
    cantidad: itemConfigCantidad.value,
    precioUnitarioUsd: itemConfigPrecio.value,
    descripcionManual: itemConfigSeleccionado.value.nombre,
    descuentoPorcentaje: 0,
    garantiaMeses: Math.floor(itemConfigGarantia.value / 30),
    garantiaDescripcion: '',
    tiempoEstimado: '',
    observaciones: ''
  };
  
  // ⭐ CAMBIO: unshift agrega al PRINCIPIO de la lista
  form.detalles.unshift(nuevoItem);
  
  if (itemConfigGarantia.value > 0) {
    toast(`✅ Garantía de ${formatearGarantia(itemConfigGarantia.value)} aplicada al ${itemConfigTipo.value === 'servicio' ? 'servicio' : 'producto'} "${itemConfigSeleccionado.value.nombre}"`);
  }
  
  closeItemConfigModal();
};

const closeItemConfigModal = () => {
  showItemConfigModal.value = false;
  itemConfigSeleccionado.value = null;
  itemConfigPrecio.value = 0;
  itemConfigGarantia.value = 0;
  itemConfigCantidad.value = 1;
};

const cargarDatos = async () => {
  try {
    console.log('📋 Cargando datos para cotización...');
    
    const clientesRes = await obtenerClientes();
    if (clientesRes.success) {
      clientes.value = clientesRes.data || [];
      todosLosClientes.value = clientesRes.data || [];
      console.log('✅ Clientes cargados:', clientes.value.length);
    }
    
    const productosRes = await obtenerProductos('todos');
    if (productosRes.success) {
      productos.value = productosRes.data || [];
      console.log('✅ Productos cargados:', productos.value.length);
    }
    
    const serviciosRes = await obtenerServicios('todos');
    if (serviciosRes.success) {
      servicios.value = serviciosRes.data || [];
      console.log('✅ Servicios cargados:', servicios.value.length);
    }
    
    try {
      const psRes = await obtenerProductosServicios();
      if (psRes.success) {
        productosServicios.value = psRes.data || [];
      }
    } catch (e) {
      console.warn('⚠️ No se pudo cargar productos/servicios especiales:', e.message);
    }
    
    const tasasRes = await obtenerTasasVenta();
    if (tasasRes.success) {
      tasas.value = tasasRes.data || [];
      console.log('✅ Tasas cargadas:', tasas.value.length);
      
      const tasaActiva = tasas.value.find(t => t.activa === true || t.activa === 1);
      if (tasaActiva) {
        form.tasaBsUsd = tasaActiva.precioUsdBs || tasaActiva.precio_usd_bs || 52.00;
        form.idTasaVenta = tasaActiva.idTasaVenta || tasaActiva.id || 1;
      } else {
        form.tasaBsUsd = 52.00;
        form.idTasaVenta = 1;
      }
    } else {
      form.tasaBsUsd = 52.00;
      form.idTasaVenta = 1;
    }
    
    const fuentesRes = await obtenerFuentesTasa();
    if (fuentesRes.success) {
      fuentes.value = fuentesRes.data || [];
      if (fuentes.value.length > 0) {
        form.idFuenteTasa = fuentes.value[0].idFuenteTasa;
      } else {
        form.idFuenteTasa = 1;
      }
    } else {
      form.idFuenteTasa = 1;
    }
    
    console.log('📋 Datos cargados completos');
    
  } catch (error) {
    console.error('❌ Error cargando datos:', error);
    form.tasaBsUsd = 52.00;
    form.idFuenteTasa = 1;
    form.idTasaVenta = 1;
  }
};

const guardarCotizacion = async () => {
  if (!form.idCliente) {
    toast('Seleccione un cliente', 'warning');
    return;
  }
  
  if (!form.fechaValidez) {
    toast('Seleccione una fecha de validez', 'warning');
    return;
  }
  
  if (!form.tasaBsUsd || form.tasaBsUsd <= 0) {
    toast('La tasa de cambio no es válida. Intente recargar la página.', 'warning');
    return;
  }
  
  if (form.detalles.length === 0) {
    toast('Agregue al menos un item', 'warning');
    return;
  }

  for (const item of form.detalles) {
    if (item.precioUnitarioUsd <= 0) {
      toast('El precio unitario debe ser mayor a 0 en todos los items', 'warning');
      return;
    }
  }

  guardando.value = true;
  try {
    const data = {
      idCliente: parseInt(form.idCliente),
      fechaValidez: new Date(form.fechaValidez).toISOString(),
      idUsuario: form.idUsuario,
      tasaBsUsd: parseFloat(form.tasaBsUsd) || 52.00,
      idFuenteTasa: parseInt(form.idFuenteTasa) || 1,
      idTasaVenta: parseInt(form.idTasaVenta) || 1,
      formaPago: form.formaPago || 'EFECTIVO',
      condicionesPago: form.condicionesPago || '',
      observaciones: form.observaciones || '',
      idSede: form.idSede || 1,
      detalles: form.detalles.map(item => ({
        tipoItem: item.tipoItem,
        idProducto: item.idProducto ? parseInt(item.idProducto) : null,
        idServicio: item.idServicio ? parseInt(item.idServicio) : null,
        idProductoServicios: item.idProductoServicios ? parseInt(item.idProductoServicios) : null,
        descripcionManual: item.descripcionManual || '',
        cantidad: parseInt(item.cantidad) || 1,
        precioUnitarioUsd: parseFloat(item.precioUnitarioUsd) || 0,
        descuentoPorcentaje: parseFloat(item.descuentoPorcentaje) || 0,
        garantiaMeses: parseInt(item.garantiaMeses) || 0,
        garantiaDescripcion: item.garantiaDescripcion || '',
        tiempoEstimado: item.tiempoEstimado || '',
        observaciones: item.observaciones || ''
      }))
    };
    
    console.log('📤 Enviando datos:', JSON.stringify(data, null, 2));
    
    const response = await crearCotizacion(data);
    if (response.success) {
      toast('Cotización creada correctamente');
      setTimeout(() => {
        router.push('/cotizaciones');
      }, 500);
    } else {
      toast(response.error || 'Error al crear cotización', 'error');
    }
  } catch (error) {
    console.error('❌ Error:', error);
    toast(error.message || 'Error al crear cotización', 'error');
  } finally {
    guardando.value = false;
  }
};

const toast = (message, icon = 'success') => {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title: message,
    customClass: { popup: 'rounded-2xl' }
  });
};

onMounted(() => {
  cargarDatos();
});
</script>

<style scoped>
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
.animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }

/* Extra small devices (teléfonos muy pequeños) */
@media (max-width: 480px) {
  .xs\:inline { display: inline !important; }
}
</style>